import { Box, Button, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { openTab } from '../../Helpers'
import { useUrlSearchParam } from 'shared/hooks'
import { SheetParamKey } from './types'
import { useSheetIds } from './hooks'

export function SheetSelection() {
  const getSheetIDs = useSheetIds()
  const [sheetId, setSheetId] = useUrlSearchParam(SheetParamKey)
  const [sheets, setSheets] = useState<{ sheetId: number; title: string }[]>([])

  useEffect(() => {
    getSheetIDs().then((ids) => setSheets(ids))
  }, [getSheetIDs])

  const onSelection = ({ target: { value } }: SelectChangeEvent) => {
    setSheetId(value)
  }

  return (
    <Box>
      <Box>
        <Box>Select Sheet Summary Source</Box>
        <Box>
          Selecting a sheet will retrieve the sheet contents and look for
          entries that pertain to this tree.
        </Box>
        <Button
          onClick={() =>
            openTab(
              'https://docs.google.com/spreadsheets/d/13M74BvrwhG247UhwqyxCkR8rajQkGqtuQ7JBMQbLj08/edit?gid=0',
            )
          }
        >
          Open Sheet
        </Button>
      </Box>
      <Select value={sheetId} onChange={onSelection}>
        {!sheets.length && <Box>Retrieving sheet tabs....</Box>}
        {sheets.map(({ sheetId, title }) => {
          return (
            <MenuItem key={sheetId} value={sheetId}>
              {title}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}
